module.exports = __webpack_public_path__ + "static/media/mariadb-logo.b78f62ee.png";